import React from 'react';
import { Card } from '@/components/ui/card';
import { cn } from 'cn';

// Card that shows a blue focus ring when it or any field inside it is focused
export function FocusHighlightCard({
  className,
  ...props
}: React.ComponentProps<typeof Card>) {
  return (
    <Card
      tabIndex={0}
      className={cn(
        'tw:bg-transparent tw:focus-within:ring-2 tw:focus-within:ring-blue-500 tw:focus:ring-2 tw:focus:ring-blue-500 tw:focus:outline-none',
        className
      )}
      {...props}
    />
  );
}
